import request from '@/utils/request'

// 查询自己的上架 eSIM 产品
export function findAgentsEsimProducts(params) {
  return request({
    url: `/customer/agents_esim_products`,
    method: 'get',
    params
  })
}
